import { MODELS_COMPARE } from 'src/store/ActionTypes';

export const fetchModels = (ids) => ({
  type: MODELS_COMPARE.FETCH_MODELS,
  payload: ids,
});

/**
 * setAvailableQuantiles - update the list of available quantiles to view
 * @param {{current: number[], premiums: number[]|undefined, persons: number[]|undefined}} availableQuantiles
 * @return {{type: string, payload: {current: number[], premiums: number[]|undefined, persons: number[]|undefined}}}
 */
export const setAvailableQuantiles = (availableQuantiles) => ({
  type: MODELS_COMPARE.SET_QUANTILES,
  payload: availableQuantiles,
});

export const setQuantiles = (numBin) => ({
  type: MODELS_COMPARE.SET_QUANTILES,
  payload: numBin,
});

/**
 * setEqualType - set the equalType of actuarial lift charts
 * @param {string} equalType
 * @return {{payload: string, type: string}}
 */
export const setEqualType = (equalType) => ({
  type: MODELS_COMPARE.SET_EQUAL_TYPE,
  payload: equalType,
});

export const setChart = (chart) => ({
  type: MODELS_COMPARE.SET_CHART,
  payload: chart,
});

export const resetPage = () => ({
  type: MODELS_COMPARE.RESET_PAGE,
});

/**
 * unset - Reset a redux state key to its default
 * @param key {string} the state key to reset
 * @returns {{payload: string, type: string}}
 */
export const unset = (key) => ({
  type: MODELS_COMPARE.UNSET,
  payload: key,
});
